import { render, staticRenderFns } from "./DisplayCouponDetail.vue?vue&type=template&id=52d97b65&scoped=true&"
import script from "./DisplayCouponDetail.vue?vue&type=script&lang=ts&"
export * from "./DisplayCouponDetail.vue?vue&type=script&lang=ts&"
import style0 from "./DisplayCouponDetail.vue?vue&type=style&index=0&id=52d97b65&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d97b65",
  null
  
)

export default component.exports